export default __webpack_public_path__ + "static/media/DSZ Price Shipping Fee Review_04092025.2ce49a5e.zip";